import script from "./wishlist-share-page.vue?vue&type=script&setup=true&lang=js"
export * from "./wishlist-share-page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__